// extracted by mini-css-extract-plugin
module.exports = {"container":"Templates_container__IioSV","innerTable":"Templates_innerTable__XlIro","inner":"Templates_inner__2R7VY"};